import styled from 'styled-components';
import Button from '@mui/material/Button';
import React from 'react';
import BMapsTooltip from 'BMapsUI/BMapsTooltip';

const controlButtonCss = `
    margin: 0;
    background-color: black;
    color: var(--mol-button-text-color);
    height: var(--mol-button-size);
    width: var(--mol-button-size);
    border-radius: calc(var(--mol-button-size)/6);
    font-size: calc(var(--mol-button-size)/5);
    padding: 0.5vh;
    font-family: var(--font-family);
    margin: 0 var(--mol-button-margin) 0 var(--mol-button-margin);
    text-transform: none;
    letter-spacing: normal;
    line-height: normal;
    min-width: unset;

    &:hover {
        border: 0.5vh solid var(--mol-button-text-color); 
        background-color: black;
        padding: 0;
    }
`;

const ControlButton = React.forwardRef(({
    title, placement, TooltipProps, ...props
}, ref) => (
    <BMapsTooltip
        noMaxWidth
        useColorScheme
        title={title ?? ''}
        placement={placement ?? 'left'}
        {...TooltipProps}
    >
        <Button ref={ref} disableRipple {...props} />
    </BMapsTooltip>
));
export default styled(ControlButton)`
    ${controlButtonCss}
`;
